/**
 * @file コンポーネント：価格 スタイル管理
 */

// ライブラリ読み込み
import styled from "styled-components";

// スタイル
export const StyledPrice = styled.span`
    display: inline-flex;
    align-items: flex-end;
    color: #ad401f;
`;

export const StyledPriceNumber = styled.span`
    margin-right: 4px;
    font-size: 14px;
`;

export const StyledPricePurchased = styled.span`
    color: #000000;
    font-size: 14px;
`;

export const StyledPriceTax = styled.span`
    font-size: 10px;
`;

export const StyledPriceUnit = styled.span`
    margin-right: 4px;
    font-size: 14px;
`;
